// Separate from React/i18next so retry and concurrent-load behaviour can be tested.
export function createCatalogLoader(importCatalog) {
  const cached = new Map();
  const pending = new Map();
  return {
    peek: locale => cached.get(locale),
    load(locale) {
      if (cached.has(locale)) return Promise.resolve(cached.get(locale));
      if (pending.has(locale)) return pending.get(locale);
      const promise = Promise.resolve().then(() => importCatalog(locale)).then(module => {
        const catalog = module.default || module;
        if (!catalog || !Object.keys(catalog).length || Object.values(catalog).some(value => typeof value !== 'string' || !value.trim())) {
          throw new Error(`Invalid translation catalog: ${locale}`);
        }
        cached.set(locale, catalog);
        return catalog;
      }).finally(() => pending.delete(locale));
      pending.set(locale, promise);
      return promise;
    },
  };
}
